<template>
    <div>
        <TaskInformation :task-id="taskId" />

        <GeneralInformation :task-id="taskId" />

        <Notes :task-id="taskId" v-if="taskBits.viewNotes" />

        <TaskSurveyForm :task-id="taskId" v-if="taskId"></TaskSurveyForm>

        <TaskRibbon :task-id="taskId"
                    :complete="taskBits.canComplete"
                    :redirect="taskBits.canRedirect"
                    :rework="taskBits.canRework"
                    :close="taskBits.canClose"
                    @complete="onComplete"
                    @succeed="succeeded"
                    @rework="onRework" />
    </div>
</template>
<script>
    import TasksService from '@/services/TasksService.js'
    import TaskInformation from '@/components/app/task/TaskInformation.vue'
    import Notes from '@/components/app/task/Notes.vue'
    import TaskSurveyForm from '@/components/app/task/survey/TaskSurveyForm.vue'
    import GeneralInformation from '@/components/app/task/dynamic/GeneralInformation.vue'
    import TaskRibbon from '@/components/app/task/TaskRibbon.vue'

    export default {

        components: {
            TaskInformation,
            GeneralInformation,
            Notes,
            TaskSurveyForm,
            TaskRibbon,
        },

        props: {
            taskId: {
                type: Number,
                default: null
            }
        },

        data() {
            return {
                workProgramsDialog: false,
                taskBits: {
                    activityDefinitionName: null,
                    canRedirect: false,
                    canRework: false,
                    canClose: false,
                    canComplete: false,
                }
            }
        },

        computed: {

        },

        created() {
            this.getTaskBits()
        },

        methods: {

            getTaskBits() {

                TasksService.getTaskBits(this.taskId).then(res => {
                    if (res.data != null) {
                        this.taskBits = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },


            onComplete(proceedCallBackMethod) {
                proceedCallBackMethod(null)
            },

            onRework(proceedCallBackMethod) {
                proceedCallBackMethod(null)
            },

            succeeded(success) {
                this.$emit('completed', success)
            }
        }
    }
</script>